// extracted by mini-css-extract-plugin
export default {"row":"AnswerButtonsV1_row__gGqWE","button":"AnswerButtonsV1_button__9gm8c"};